class ProductTabs {

  #links = document.querySelectorAll('.product-tab-link');
  #mobileLinks = document.querySelectorAll('.product-tab-link-m');
  #allLinks = document.querySelectorAll('.product-tab-link, .product-tab-link-m');
  #contents = document.querySelectorAll('.product-tab-content');
  #mobileBreakpoint = 1024;


  constructor(callbacks = []) {
    this.init(callbacks);
  }

  init(callbacks = []) {

    callbacks.forEach((callback) => {
      callback();
    });

    this.#allLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        this.doSelect(e.currentTarget);
      }.bind(this));
    }.bind(this));

  }

  doSelect(tabLink, isTriggerTabLink = true) {
    const mobile = this.isMobile(isTriggerTabLink, tabLink);
    const contentTarget = document.getElementById(tabLink.dataset.targetid);
    const linkTarget = document.querySelector('.product-tab-link[data-targetid=' + tabLink.dataset.targetid + ']');
    const linkTargetMobile = document.querySelector('.product-tab-link-m[data-targetid=' + tabLink.dataset.targetid + ']');
    const className = mobile ? 'active-m' : 'active';
    const linksForDeselect = mobile ? this.#mobileLinks : this.#links;
    const distanceFromScreenTop = tabLink.getBoundingClientRect().top;

    if (tabLink.classList.contains('active-m')) {
      tabLink.classList.remove('active-m');
      contentTarget.classList.remove('active-m');
      return;
    }

    this.deselectOthers(linksForDeselect, className);


    if (mobile) {
      linkTargetMobile.classList.add(className);
    } else {
      linkTarget.classList.add(className);
    }

    contentTarget.classList.add(className);

    if (mobile && isTriggerTabLink) {
      this.keepScrollPosition(tabLink, distanceFromScreenTop);
    }

    if (!isTriggerTabLink) {
      this.scrollToContent(contentTarget);
    }

    if (isTriggerTabLink) {
      this.simulateScroll();
    }
  }


  isMobile(isTriggerTabLink, target) {
    let mobile;
    if (!isTriggerTabLink) {
      mobile = window.innerWidth <= this.#mobileBreakpoint;
    } else {
      mobile = target.classList.contains('product-tab-link-m');
    }
    return mobile;
  }


  /**
   * Deselect all other links and contents by removing the class name
   * @param links - the links to deselect
   * @param className - the class name to remove
   */
  deselectOthers(links, className) {
    links.forEach(link => {
      link.classList.remove(className);
    });
    this.#contents.forEach(content => {
      content.classList.remove(className);
    });
  }


  /**
   * Keep the scroll position when the tab is clicked
   * @param target - the clicked tab
   * @param distanceFromTop
   */
  keepScrollPosition(target, distanceFromTop) {
    const distanceFromPageTop = target.offsetTop;
    const targetPos = distanceFromPageTop - distanceFromTop;
    document.querySelector('sticky-header').dispatchEvent(new CustomEvent('preventHeaderReveal'));
    window.scrollTo({
      top: targetPos
    });
  }


  /**
   * Simulate scroll to trigger the scroll event ( For Judge.me reviews )
   */
  simulateScroll() {
    window.scrollBy(0, 1);
    window.scrollBy(0, -1);
  }

  /**
   * Scroll to the content of the tab
   * @param content
   */
  scrollToContent(content) {
    window.scrollBy({
      top: content.getBoundingClientRect().top
    });
  }

}


/**
 * Select the tab and content
 */
class RateHook {
  constructor(starsSelector, tabLinkSelector, tabsInstance) {
    this.rateHook = document.querySelector(starsSelector);
    this.tabLink = document.querySelector(tabLinkSelector);
    this.tabsInstance = tabsInstance;
  }

  init() {
    if (this.rateHook) {
      this.rateHook.style.cursor = 'pointer';
      this.rateHook.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.tabsInstance.doSelect(this.tabLink, false);
      }.bind(this));
    }
  }
}


class ProductSpecifications {

  container = document.querySelector('.app__easy-specs-container');
  hiddenElems = document.querySelectorAll('.js__product-specs-hidden');


  observerSpecs() {
    this.showSpecs();
    const config = { childList: true };
    const callback = function(mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          // Check if content was added to the div
          if (mutation.addedNodes.length > 0) {
            this.showSpecs();
          }
        }
      }
    }.bind(this);

    const observer = new MutationObserver(callback);
    observer.observe(this.container, config);
  }


  showSpecs() {
    const table = document.querySelector('.easyspecs-table');
    if (table && table.childNodes.length > 0) {
      this.hiddenElems.forEach((elem) => {
        elem.classList.remove('js__product-specs-hidden');
      });
    }
  }
}

class ProductDownloads {

  container = document.querySelector('.tigren-attachments');
  hiddenElems = document.querySelectorAll('.js__product-files-hidden');

  showDownloads() {
    if (this.container.childNodes.length > 0) {
      this.hiddenElems.forEach((elem) => {
        elem.classList.remove('js__product-files-hidden');
      });
    }
  }
}




document.addEventListener('DOMContentLoaded', () => {
  const downloadsInstance = new ProductDownloads();
  const specsInstance = new ProductSpecifications();

  const tabsInstance = new ProductTabs([
    downloadsInstance.showDownloads.bind(downloadsInstance),
    specsInstance.observerSpecs.bind(specsInstance)
  ]);

  const rateHook = new RateHook('.jdgm-prev-badge__stars, .rating', '.product-tab-link[data-targetid="js__product-revs"]', tabsInstance);
  rateHook.init();
});


